removeById = require 'lib/util/array/remove-by-id'
_ = require 'underscore'
Util = require 'lib/util'

class Renderable
  constructor: (args...) ->
    @selected = false

    @source = args[0]
    @id = args[0].get('id')
    for attr in @ATTRIBUTES
      @[attr] = args[0].get(attr)

    @_parseAttributes(args...)

  # in case a child class doesn't implement it
  _parseAttributes: ->

  isSearchMatch: (searchTerm) ->
    _.any @SEARCH_FIELDS, (field) =>
      @[field].toLowerCase().indexOf(searchTerm.toLowerCase()) != -1

  toBackbone: ->
    @source

module.exports.Team = class Team extends Renderable
  SEARCH_FIELDS: ['displayName', 'name']
  ATTRIBUTES: ['logoHash', 'name', 'displayName']

  _parseAttributes: (team) ->
    @boards = team.boardList.filter (board) ->
      !board.get('closed')
    @memberCount = team.get('memberships').length

module.exports.Member = class Member extends Renderable
  # used to search in the main members tab
  API_SEARCH_FIELDS: [
    { fieldName: 'username' }
    { fieldName: 'fullName' }
    {
      fieldName: 'emails.value'
      useIfTermMatches: (term) ->
        Util.checkEmail(term, "A-Z") }
  ]
  # used in popovers
  SEARCH_FIELDS: ['username', 'fullName', 'email']
  ATTRIBUTES: [
    'active'
    'avatarHash'
    'fullName'
    'id'
    'initials'
    'username'
    'email'
  ]

  _parseAttributes: (member, orgs) ->
    @organizations = orgs
    @isDeactivated = !member.get('active')
    @hasTransferred = 'enterprise.owned' in member.get('roles')
    @avatarDomain = window.avatarDomain
    @type = if member.get('memberType') == 'ghost'
        'virtual'
      else if !member.get('confirmed')
        'unconfirmed'
      else if 'enterprise.admin' in member.get('roles')
        'admin'
      else if 'organization.admin' in member.get('roles')
        'team-admin'
      else if member.get('userType') == 'collaborator'
        'collaborator'

  orgAdded: (org) ->
    @organizations.push(org)
    @isDeactivated = false
    @type = if @toBackbone().get('memberType') == 'ghost'
        'virtual'
      else if !@toBackbone().get('confirmed')
        'unconfirmed'

  orgRemoved: (org) ->
    return unless @organizations

    @organizations = removeById(@organizations, org)

  orgDeactivated: ->
    @isDeactivated = _.all @organizations,
      (org) => org.getMembershipFor(@toBackbone()).deactivated

  orgReactivated: ->
    @isDeactivated = false



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/renderable-items.coffee